import React from "react";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header className="w-full bg-white border-b border-slate-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center">
        <Link to="/" className="flex items-center gap-3">

          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#1A6FE8] to-[#1255C0] flex items-center justify-center shadow-md">
            <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center">
              <span className="text-[#1A6FE8] font-black text-lg leading-none">
                +
              </span>
            </div>
          </div>

          <div className="leading-tight">
            <div className="text-2xl font-black tracking-tight text-[#0D1B2A]">
              <span className="text-[#1A6FE8]">Pin</span>MyDoc
            </div>
          </div>

        </Link>
      </div>
    </header>
  );
}